<template>
  <div class="d-flex flex-column align-items-center fade-in">
    <content-header title="Forms" :sub-title="subTitle" class="w-100 mxw-md px-10"/>
    <el-row class="form-container  mxw-md " :gutter="20">
      <el-col v-bind="responsiveCol" v-for="form in forms" :key="form._id">
          <el-card shadow="never" :class="{ 'box-card': true, 'd-flex': true, 'flex-column': true, 'form-card': true }" @click.native="selectForm(form._id)">
            <div class="d-flex flex-column">
              <div class="flex-1 d-flex">
                <div class="member-info flex-1 d-flex flex-column">
                  <div class="name">{{ form.name }}</div>
                  <div class="description">
                    <vue-clamp autoresize :max-lines="5">{{ form.description }}</vue-clamp>
                  </div>
                </div>
                <div class="organization mt-2">{{ getEntity(form) }}</div>
              </div>
            </div>
          </el-card>
        </el-col>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FormsList',
  data() {
    return {
      subTitle: 'Below are the forms and questionaires provided by your organisations',
      forms: [],
      responsiveCol: {
        xs: 24, sm: 12, md: 12, lg: 12
      }
    };
  },
  mounted() {
    this.$store.commit('loading', { loading: true, text: 'Loading...' });
    // this.$http.get('assemble/api/v1/portal/forms')
    //   .then((res) => {
    //     this.forms = res.data.data;
    //   })
    //   .catch((err) => {
    //     this.errorMessage = err.response.data.message;
    //   })
    //   .finally(() => {
    //     this.$store.commit('loading', false);
    //   });

    this.getForms();
  },
  methods: {
    getCreatedByName(data) {
      // find object in orgtree that match the entityType
      const { entityType, orgtree } = data;
      if (entityType) {
        const entityDetails = orgtree[entityType];
        return entityDetails.name;
      }
      return 'N/A';
    },
    getEntity(row) {
      let entityName = '';
      if (_.get(row, 'isClone')) {
        entityName = _.get(row, 'entityObjects[0].name', '');
      }
      entityName = _.get(row, `orgtree[${row.entityType}].name`, '');

      if (entityName === '') {
        entityName = this.getOrgName(row);
      }
      return entityName || 'N/A';
    },
    async getForms() {
      try {
        const res = await this.$http.post('assemble/api/v1/portal/forms');
        this.forms = res.data.data;
      } catch (error) {
        console.log(error);
        this.errorMessage = error.response.data.message;
      } finally {
        this.$store.commit('loading', false);
      }
    },
    selectForm(id) {
      const pathName = this.hasCustomEntity ? 'custom-forms' : 'forms';
      this.$router.push({ name: pathName, query: { formId: id } });
    },
    getOrgName(form) {
      let orgName = '';
      if (form.orgtree && form.orgtree.national) {
        orgName = form.orgtree.national.name;
      } else if (form.orgtree && form.orgtree.state) {
        orgName = form.orgtree.state.name;
      } else if (form.orgtree && form.orgtree.association) {
        orgName = form.orgtree.association.name;
      } else if (form.orgtree && form.orgtree.club) {
        orgName = form.orgtree.club.name;
      }

      return orgName;
    }
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
  .form-container {
    padding: 0 2.5vmin;
    width: 100%;

    .form-card {
      margin-bottom: 2vmin;
      padding: 1em;
      min-height: 15em;
      cursor: pointer;
      border: 1px solid #eee;

      &:hover {
        border: 1px dashed rgba($highlight, 0.5);
      }

      ::v-deep .el-card__body {
        padding: 0.5em;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
      }

      .name {
        font-size: clamp(1.6rem, 1.7vmin, 2rem);
        line-height: 34px;
        flex: 0 0 auto;
      }

      .organization {
        font-size: clamp(1.1rem, 1.1vmin, 1.7rem);
        line-height: 14px;
        flex: 0 0 auto;
      }

      .description {
        margin-top: 2vmin;
        font-family: 'BrownStd-Light';
        font-size: clamp(.85rem, 1vmin, 1.1rem);
        color: #606266;
        line-height: 20px;
        flex: 1 1 auto;
        font-family: 'BrownStd-Light';
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
</style>
